<template>
  <div class="container">
    <myNav></myNav>
    <div class="pro-con">
      <el-row>
        <el-col :span="12">
          <div class="inf-con"><img :src="this.proData[0].main_img_url" alt="" /></div>
        </el-col>
        <el-col :span="12">
          <div class="info-text">供应商名称：{{ proName }}</div>
          <div class="info-text">联系人：{{ liaison }}</div>
          <div class="info-text">联系方式：{{ phone }}</div>
          <div class="info-text">联系地址：{{ address }}</div>
        </el-col>
      </el-row>
      <el-row>
        <div class="pro-re">产品介绍：</div>
        <div>{{ memo }}</div>
      </el-row>
    </div>
  </div>
</template>
<script>
import myNav from './nav/myNav'
import { proModuleApi } from '@/api/home'
export default {
  name: 'supplier',
  components: {
    myNav
  },
  data() {
    return {
      id: '',
      proData: {},
      name: '',
      proName: '',
      liaison: '',
      phone: '',
      address: '',
      memo: ''
    }
  },
  created() {
    this.id = this.$route.query.id
    console.log(this.id)
    this.getProInfo()
  },
  methods: {
    getProInfo() {
      proModuleApi
        .getSupplier()
        .then(res => {
          this.proData = res.data.filter(item => item.id == this.id)
          console.log(this.proData)
          this.proName = this.proData[0].name
          this.liaison = this.proData[0].liaison
          this.phone = this.proData[0].phone
          this.address = this.proData[0].address
          this.memo = this.proData[0].memo
        })
        .catch()
    }
  }
}
</script>
<style scoped>
.pro-con {
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
}

.el-col {
  padding: 10px 20px;
}
.sup-item {
  width: 100%;
  height: 300px;
  /* text-align: center; */
  box-shadow: 0 0 8px 0 #cfcfcf;
  border-radius: 5px;
  padding: 5px 10px;
}

.sup-img {
  width: 100%;
  height: 200px;
  text-align: center;
}

.sup-img img {
  max-width: 100%;
  max-height: 180px;
}

.sup-title {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  /* display: -webkit-box; */
  text-align: center;
  font-weight: bold;
  color: #107a53;
}
.sup-text {
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.inf-con {
  box-shadow: 0 0 8px #cfcfcf;
  text-align: center;
}
.inf-con img {
  width: 100%;
}
.info-text {
  font-size: 18px;
  margin-bottom: 20px;
}
.pro-re {
  background-color: #107a53;
  color: #fff;
  font-size: 22px;
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier.vue